/* ═══════════════════════════════════════════
   ANNOUNCEMENT CAROUSEL
═══════════════════════════════════════════ */
(function() {
  const slides = document.querySelectorAll('.announce-slide');
  if (!slides.length) return;
  let cur = 0, timer;

  function goTo(n) {
    slides[cur].classList.remove('active');
    cur = (n + slides.length) % slides.length;
    slides[cur].classList.add('active');
  }
  function start() { timer = setInterval(() => goTo(cur + 1), 4000); }
  function stop()  { clearInterval(timer); }

  const nextBtn = document.querySelector('.announce-nav.next');
  const prevBtn = document.querySelector('.announce-nav.prev');
  const announceEl = document.getElementById('announce');
  if (nextBtn) nextBtn.addEventListener('click', () => { stop(); goTo(cur + 1); start(); });
  if (prevBtn) prevBtn.addEventListener('click', () => { stop(); goTo(cur - 1); start(); });
  if (announceEl) {
    announceEl.addEventListener('mouseenter', stop);
    announceEl.addEventListener('mouseleave', start);
  }
  start();
})();

/* ═══════════════════════════════════════════
   REVIEWS CAROUSEL — dot tracker
═══════════════════════════════════════════ */
(function() {
  const grid = document.getElementById('reviewsGrid');
  const dots = document.querySelectorAll('.reviews-dot');
  if (!grid || !dots.length) return;

  function updateDots() {
    const cards = grid.querySelectorAll('.review-card');
    const cardW = cards[0] ? cards[0].offsetWidth + 14 : 1;
    const idx = Math.round(grid.scrollLeft / cardW);
    dots.forEach((d, i) => d.classList.toggle('active', i === idx));
  }

  grid.addEventListener('scroll', updateDots, { passive: true });
  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      const cards = grid.querySelectorAll('.review-card');
      const cardW = cards[0] ? cards[0].offsetWidth + 14 : 0;
      grid.scrollTo({ left: parseInt(dot.dataset.idx) * cardW, behavior: 'smooth' });
    });
  });
})();

/* ═══════════════════════════════════════════
   BACK TO TOP
═══════════════════════════════════════════ */
const backToTop = document.getElementById('backToTop');
if (backToTop) {
  window.addEventListener('scroll', () => {
    backToTop.classList.toggle('visible', window.scrollY > 600);
  }, { passive: true });
  backToTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
}

/* ═══════════════════════════════════════════
   NAV SCROLL SHADOW
═══════════════════════════════════════════ */
const mainNav = document.getElementById('mainNav');
if (mainNav) {
  window.addEventListener('scroll', () => {
    mainNav.classList.toggle('scrolled', window.scrollY > 10);
  }, { passive: true });
}

/* ═══════════════════════════════════════════
   MOBILE NAV
═══════════════════════════════════════════ */
const mobileNav = document.getElementById('mobileNav');
const navToggle = document.getElementById('navToggle');
const navClose  = document.getElementById('navClose');
if (navToggle && mobileNav) navToggle.addEventListener('click', () => mobileNav.classList.add('open'));
if (navClose  && mobileNav) navClose.addEventListener('click',  () => mobileNav.classList.remove('open'));

function closeMobileNav() {
  if (!mobileNav) return;
  mobileNav.classList.remove('open');
  const subs   = document.getElementById('mobileShopSubs');
  const toggle = document.getElementById('mobileShopToggle');
  if (subs)   subs.classList.remove('open');
  if (toggle) toggle.classList.remove('open');
}

(function() {
  const toggle = document.getElementById('mobileShopToggle');
  const subs   = document.getElementById('mobileShopSubs');
  if (!toggle || !subs) return;
  toggle.addEventListener('click', function() {
    const isOpen = subs.classList.contains('open');
    subs.classList.toggle('open', !isOpen);
    this.classList.toggle('open', !isOpen);
  });
})();

/* ═══════════════════════════════════════════
   SHOPIFY CART — AJAX API
═══════════════════════════════════════════ */
function formatMoney(cents) {
  const amount = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const fmt = window.trMoneyFormat || '${{amount}}';
  return fmt.replace('{{amount_no_decimals}}', amount)
            .replace('{{amount}}', amount);
}

function updateCartBadge(count) {
  const cc = document.getElementById('cartCount');
  const cb = document.getElementById('cartBubble');
  const mc = document.getElementById('mobileCartCount');
  const dc = document.getElementById('cartDrawerCount');
  if (cc) { cc.textContent = count > 0 ? count : ''; cc.classList.toggle('has-items', count > 0); }
  if (cb) { cb.textContent = count; cb.classList.toggle('has-items', count > 0); }
  if (mc) mc.textContent = count;
  if (dc) dc.textContent = count;
}

// Cache product first images to avoid repeat fetches
const _productImgCache = {};
async function getProductFirstImage(handle) {
  if (_productImgCache[handle] !== undefined) return _productImgCache[handle];
  try {
    const res = await fetch(`/products/${handle}.js`);
    const product = await res.json();
    _productImgCache[handle] = (product.images && product.images[0]) ? product.images[0].src : null;
  } catch(e) {
    _productImgCache[handle] = null;
  }
  return _productImgCache[handle];
}


function renderCartItems(items, totalPrice) {
  const itemsEl = document.getElementById('cartItems');
  const totalEl = document.getElementById('cartTotal');
  if (!itemsEl) return;

  if (!items || items.length === 0) {
    itemsEl.innerHTML = '<p class="cart-empty">Your cart is empty.<br>Add something to get started.</p>';
  } else {
    itemsEl.innerHTML = items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <img class="cart-item-img" src="${item.image || ''}" alt="${item.product_title}" data-handle="${item.handle}">
        <div class="cart-item-info">
          <p class="cart-item-name">${item.product_title}</p>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item-variant">${item.variant_title}</p>` : ''}
          <div class="cart-item-bottom">
            <p class="cart-item-price">${formatMoney(item.line_price)}</p>
            <div class="cart-qty">
              <button class="cart-qty-btn cart-qty-minus" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Decrease quantity">−</button>
              <span class="cart-qty-num">${item.quantity}</span>
              <button class="cart-qty-btn cart-qty-plus" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Increase quantity">+</button>
            </div>
          </div>
        </div>
        <button class="cart-item-remove" data-key="${item.key}" aria-label="Remove">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>
    `).join('');
    bindCartRemove();
    bindQtyButtons();

    // Swap in first product image for each item (async, no flicker)
    itemsEl.querySelectorAll('.cart-item-img[data-handle]').forEach(async img => {
      const src = await getProductFirstImage(img.dataset.handle);
      if (src) img.src = src;
    });
  }
  if (totalEl) totalEl.textContent = formatMoney(totalPrice);
}

async function refreshCart() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    updateCartBadge(cart.item_count);
    renderCartItems(cart.items, cart.total_price);
  } catch (err) {
    console.error('Cart refresh failed:', err);
  }
}

async function addToCart(variantId, quantity = 1, btn = null, silent = false) {
  if (!btn) btn = document.querySelector(`[data-variant="${variantId}"]`);
  if (btn && btn.dataset.loading) return;

  var originalText = btn ? btn.textContent.trim() : 'ADD TO CART';

  function resetBtn(delay = 0) {
    if (!btn) return;
    const run = () => {
      btn.textContent = originalText;
      btn.style.opacity = '1';
      delete btn.dataset.loading;
    };
    delay ? setTimeout(run, delay) : run();
  }

  if (btn) {
    btn.dataset.loading = '1';
    btn.textContent = 'Adding…';
    btn.style.opacity = '.7';
  }

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });

    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      console.error('Cart add failed:', res.status, data);
      const isOutOfStock = res.status === 422;
      if (btn) {
        btn.textContent = isOutOfStock ? 'Out of Stock' : 'Error — Try Again';
        btn.style.opacity = '1';
        btn.style.background = isOutOfStock ? '#999' : '#c00';
      }
      resetBtn(2500);
      return false;
    }

    await refreshCart();
    if (!silent) openCartDrawer();
    if (btn) {
      btn.textContent = '✓ Added!';
      btn.style.opacity = '1';
    }
    resetBtn(2000);
    return true;
  } catch (err) {
    console.error('Add to cart error:', err);
    resetBtn();
    return false;
  }
}

async function removeFromCart(key) {
  try {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: { [key]: 0 } })
    });
    await refreshCart();
  } catch (err) {
    console.error('Remove from cart error:', err);
  }
}

function bindCartRemove() {
  document.querySelectorAll('.cart-item-remove').forEach(btn => {
    btn.addEventListener('click', () => removeFromCart(btn.dataset.key));
  });
}

async function updateQty(key, newQty) {
  try {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: { [key]: newQty } })
    });
    await refreshCart();
  } catch (err) {
    console.error('Qty update error:', err);
  }
}

function bindQtyButtons() {
  document.querySelectorAll('.cart-qty-minus').forEach(btn => {
    btn.addEventListener('click', () => {
      const newQty = parseInt(btn.dataset.qty) - 1;
      updateQty(btn.dataset.key, Math.max(0, newQty));
    });
  });
  document.querySelectorAll('.cart-qty-plus').forEach(btn => {
    btn.addEventListener('click', () => {
      const newQty = parseInt(btn.dataset.qty) + 1;
      updateQty(btn.dataset.key, newQty);
    });
  });
}

/* Wire ATC buttons */
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.add-to-cart, .add-to-cart-silent');
  if (!btn) return;
  const variantId = btn.dataset.variant;
  const qty = parseInt(btn.dataset.qty) || 1;
  const silent = btn.classList.contains('add-to-cart-silent');
  if (variantId) addToCart(parseInt(variantId), qty, btn, silent);
});

/* Wire Buy Now → Shiprocket buttons */
document.addEventListener('click', async function(e) {
  const btn = e.target.closest('.buy-now-sr');
  if (!btn) return;
  const variantId = btn.dataset.variant;
  const qty = parseInt(btn.dataset.qty) || 1;
  if (!variantId) return;
  const ok = await addToCart(parseInt(variantId), qty, btn, true);
  if (!ok) return;
  if (window.shiprocketCheckoutEvents && typeof window.shiprocketCheckoutEvents.buyCart === 'function') {
    shiprocketCheckoutEvents.buyCart(e);
  } else {
    const srBtn = document.querySelector('.sr-headless-checkout');
    if (srBtn) srBtn.click();
    else window.location.href = '/checkout';
  }
});

/* Init remove buttons on page load */
bindCartRemove();

/* ═══════════════════════════════════════════
   CART DRAWER
═══════════════════════════════════════════ */
const cartDrawer  = document.getElementById('cartDrawer');
const cartOverlay = document.getElementById('cartOverlay');

function openCartDrawer() {
  if (!cartDrawer) return;
  cartDrawer.classList.add('open');
  if (cartOverlay) cartOverlay.classList.add('open');
  document.body.style.overflow = 'hidden';
  refreshCart(); // always sync with latest cart state
}
function closeCartDrawer() {
  if (!cartDrawer) return;
  cartDrawer.classList.remove('open');
  if (cartOverlay) cartOverlay.classList.remove('open');
  document.body.style.overflow = '';
}

const cartClose   = document.getElementById('cartClose');
const cartBtn     = document.getElementById('cartBtn');
const cartBtnMob  = document.getElementById('cartBtnMobile');
if (cartClose)   cartClose.addEventListener('click', closeCartDrawer);
if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);
if (cartBtn)     cartBtn.addEventListener('click', openCartDrawer);
if (cartBtnMob)  cartBtnMob.addEventListener('click', openCartDrawer);

document.addEventListener('keydown', e => {
  if (e.key === 'Escape') { closeCartDrawer(); }
});

/* ═══════════════════════════════════════════
   SCROLL REVEAL
═══════════════════════════════════════════ */
const revealEls = document.querySelectorAll('.reveal');
if (revealEls.length) {
  const revealIO = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('visible'); revealIO.unobserve(e.target); }
    });
  }, { threshold: 0.1 });
  revealEls.forEach(el => revealIO.observe(el));
}

/* ═══════════════════════════════════════════
   FAQ ACCORDION SYMBOLS
═══════════════════════════════════════════ */
document.querySelectorAll('.faq-item').forEach(item => {
  item.addEventListener('toggle', () => {
    const sym = item.querySelector('summary span');
    if (sym) sym.textContent = item.open ? '−' : '+';
  });
});

/* ═══════════════════════════════════════════
   LAB PAGE — INGREDIENT FILTER TABS
═══════════════════════════════════════════ */
(function() {
  const tabs = document.querySelectorAll('.lab-filter-tab');
  if (!tabs.length) return;
  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      tabs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      const filter = this.dataset.filter;
      document.querySelectorAll('#ingrRows .ingr-row').forEach(row => {
        if (filter === 'all' || row.dataset.product === filter) {
          row.classList.remove('ingr-hidden');
        } else {
          row.classList.add('ingr-hidden');
          row.classList.remove('expanded');
        }
      });
    });
  });
})();

/* ═══════════════════════════════════════════
   LAB PAGE — EXPANDABLE INGREDIENT ROWS
═══════════════════════════════════════════ */
(function() {
  const rows = document.querySelectorAll('.ingr-expandable');
  if (!rows.length) return;
  rows.forEach(row => {
    row.addEventListener('click', function() {
      const isExpanded = this.classList.contains('expanded');
      rows.forEach(r => r.classList.remove('expanded'));
      if (!isExpanded) this.classList.add('expanded');
    });
  });
})();

/* ═══════════════════════════════════════════
   HERO CAROUSEL
═══════════════════════════════════════════ */
(function() {
  const carousel = document.getElementById('heroCarousel');
  if (!carousel) return;
  const slides = Array.from(carousel.querySelectorAll('.hc-slide'));
  const dots   = Array.from(carousel.querySelectorAll('.hc-dot'));
  const prev   = document.getElementById('hcPrev');
  const next   = document.getElementById('hcNext');
  let current  = 0;
  let timer;

  function goTo(idx) {
    slides[current].classList.remove('active');
    dots[current] && dots[current].classList.remove('active');
    current = (idx + slides.length) % slides.length;
    slides[current].classList.add('active');
    dots[current] && dots[current].classList.add('active');
    resetTimer();
  }
  function resetTimer() {
    clearInterval(timer);
    timer = setInterval(() => goTo(current + 1), 5000);
  }
  if (prev) prev.addEventListener('click', () => goTo(current - 1));
  if (next) next.addEventListener('click', () => goTo(current + 1));
  dots.forEach(dot => dot.addEventListener('click', () => goTo(parseInt(dot.dataset.slide))));

  let touchStartX = 0;
  carousel.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
  carousel.addEventListener('touchend', e => {
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) goTo(diff > 0 ? current + 1 : current - 1);
  });
  resetTimer();
})();

/* ═══════════════════════════════════════════
   SEARCH OVERLAY
═══════════════════════════════════════════ */
(function() {
  var searchBtn     = document.getElementById('searchBtn');
  var searchOverlay = document.getElementById('searchOverlay');
  var searchClose   = document.getElementById('searchClose');
  var searchInput   = document.getElementById('searchInput');
  if (!searchBtn || !searchOverlay) return;

  function openSearch() {
    searchOverlay.classList.add('search-visible');
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function() { if (searchInput) searchInput.focus(); }, 100);
  }
  function closeSearch() {
    searchOverlay.classList.remove('search-visible');
    searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  searchBtn.addEventListener('click', openSearch);
  searchClose.addEventListener('click', closeSearch);

  // Click backdrop to close
  searchOverlay.addEventListener('click', function(e) {
    if (e.target === searchOverlay) closeSearch();
  });

  // ESC to close
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchOverlay.classList.contains('search-visible')) closeSearch();
  });
})();

/* ═══════════════════════════════════════════
   WELCOME POPUP
═══════════════════════════════════════════ */
(function() {
  var KEY = 'tr_welcome_seen_session';
  if (sessionStorage.getItem(KEY)) return;

  var overlay = document.getElementById('wpOverlay');
  var closeBtn = document.getElementById('wpClose');
  var form     = document.getElementById('wpForm');
  var offer    = document.getElementById('wpOffer');
  var success  = document.getElementById('wpSuccess');
  var copyBtn  = document.getElementById('wpCopy');
  if (!overlay) return;

  // Show on home page only
  var body = document.body;
  var isHome = body.classList.contains('template-index');
  if (!isHome) return;

  function dismiss() {
    overlay.classList.remove('wp-visible');
    overlay.setAttribute('aria-hidden', 'true');
    sessionStorage.setItem(KEY, '1');
  }

  // ── Trigger logic ──
  var shown = false;

  function showPopup() {
    if (shown) return;
    shown = true;
    clearTimeout(timeoutId);
    window.removeEventListener('scroll', onScroll, true);
    document.removeEventListener('mouseleave', onExitIntent);
    overlay.classList.add('wp-visible');
    overlay.setAttribute('aria-hidden', 'false');
  }

  // 10-second time trigger
  var timeoutId = setTimeout(showPopup, 10000);

  // 50% scroll depth trigger
  function onScroll() {
    var scrollable = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    if (scrollable > 0 && window.scrollY / scrollable >= 0.50) showPopup();
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  // Exit intent — cursor leaving viewport toward top — desktop only
  function onExitIntent(e) {
    if (e.clientY < 5) showPopup();
  }
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseleave', onExitIntent);
  }

  if (closeBtn) closeBtn.addEventListener('click', dismiss);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) dismiss(); });

  if (form) {
    var emailInput  = document.getElementById('wpEmail');
    var submitBtn   = form.querySelector('button[type="submit"]');
    var emailRe     = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    // Start disabled
    if (submitBtn) submitBtn.disabled = true;

    // Enable only when valid email is typed
    if (emailInput && submitBtn) {
      emailInput.addEventListener('input', function() {
        submitBtn.disabled = !emailRe.test(emailInput.value.trim());
      });
    }

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var email = emailInput ? emailInput.value.trim() : '';
      if (!emailRe.test(email)) return;

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting...';
      }

      fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          access_key: 'd01a13f5-d4a1-4a88-992d-282faf8160bb',
          email: email,
          subject: 'New Subscriber — Trusted Rituals',
          from_name: 'Trusted Rituals Popup'
        })
      })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (data.success) {
          sessionStorage.setItem(KEY, '1');
          offer.classList.add('wp-fade-out');
          setTimeout(function() {
            offer.style.display = 'none';
            success.style.display = 'flex';
            success.classList.add('wp-fade-in');
          }, 280);
        } else {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Try again';
          }
        }
      })
      .catch(function() {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Try again';
        }
      });
    });
  }
  if (copyBtn) {
    copyBtn.addEventListener('click', function() {
      navigator.clipboard.writeText('RITUAL10').then(function() {
        copyBtn.textContent = 'Copied!';
        copyBtn.classList.add('wp-copied');
        setTimeout(function() {
          copyBtn.textContent = 'Copy';
          copyBtn.classList.remove('wp-copied');
        }, 2000);
      });
    });
  }
})();

/* ═══════════════════════════════════════════
   PRODUCT GRID — MOBILE TAP TO REVEAL
═══════════════════════════════════════════ */
(function() {
  if (window.matchMedia('(hover: hover)').matches) return; // desktop has CSS hover, skip
  document.addEventListener('touchstart', function(e) {
    var wrap = e.target.closest('.pgrid-img-wrap');
    if (wrap) {
      var isAlreadyTapped = wrap.classList.contains('tapped');
      // untap all others
      document.querySelectorAll('.pgrid-img-wrap.tapped').forEach(function(el) {
        el.classList.remove('tapped');
      });
      // if it wasn't tapped, tap it; if it was tapped, tapping ATC is handled by add-to-cart delegation
      if (!isAlreadyTapped) {
        wrap.classList.add('tapped');
        e.preventDefault(); // prevent accidental ATC fire on first tap
      }
    } else {
      // tapped outside — untap all
      document.querySelectorAll('.pgrid-img-wrap.tapped').forEach(function(el) {
        el.classList.remove('tapped');
      });
    }
  }, { passive: false });
})();

/* ═══════════════════════════════════════════
   FOOTER ACCORDION (mobile)
═══════════════════════════════════════════ */
(function() {
  document.querySelectorAll('.footer-nav-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var links = btn.nextElementSibling;
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', !isOpen);
      links.classList.toggle('open', !isOpen);
    });
  });
})();
